import { render, staticRenderFns } from "./BackupRepoPicker.vue?vue&type=template&id=18fb18cc&"
import script from "./BackupRepoPicker.vue?vue&type=script&lang=ts&"
export * from "./BackupRepoPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports